import { useEffect, useState } from "react";
import "./FolhaColaboradoresList.css";
import { PageHeader } from "../../page-header";
import { usePayroll } from "../../../hooks/usePayroll";
import { useNavigate } from "react-router-dom";
import { FiPlus, FiMoreVertical, FiEdit, FiTrash } from "react-icons/fi";

export default function ListagemColaboradores() {
  const { listCollaborators, loading, inactiveCollaborator } = usePayroll();
  const [collaborators, setCollaborators] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [terminationDate, setTerminationDate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCollaborator, setSelectedCollaborator] = useState(null);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    total: 0,
    totalPages: 0,
    limit: 10
  });

  const navigate = useNavigate();

  useEffect(() => {
    handleList(1);
  }, []);

  async function handleList(currentPage = page) {
    try {
      const response = await listCollaborators(currentPage);
      setCollaborators(response.data.data || []);
      setPagination(response.data.pagination || {});
      setPage(currentPage);
    } catch (error) {
      console.error(error);
    }
  }

  async function handleInactiveCollaborator() {
    try {
      await inactiveCollaborator(selectedCollaborator.id, terminationDate);
      setIsModalOpen(false);
      setTerminationDate(null);
      setSelectedCollaborator(null);
      handleList(page);
    } catch (error) {
      console.error(error);
    }
  }

  const formatCurrency = (value) => {
    if (!value) return "R$ 0,00";

    return Number(value).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  return (
    <div className="collaborator-form-container">
      <div className="col-md-10">
        <div className="mt-4 mb-3">
          <PageHeader
            title="Colaboradores"
            pages={[
              { name: "Colaboradores", link: "/folha-pagamento/dashboard" },
            ]}
          />
        </div>

        <div className="panel">
          <div className="panel-header header-with-action">
            <div className="panel-title">Lista de colaboradores</div>

            <button
              style={{ color: 'black' }}
              className="add-collaborator-btn"
              onClick={() =>
                navigate(`/folha-pagamento/colaborador/novo`)
              }
            >
              <FiPlus size={18} />
              <span>Novo</span>
            </button>
          </div>

          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>CPF/CNPJ</th>
                  <th>Email</th>
                  <th>Telefone</th>
                  <th>Cargo</th>
                  <th>Salário</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                {!loading && collaborators.length === 0 && (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center" }}>
                      Nenhum colaborador encontrado
                    </td>
                  </tr>
                )}

                {collaborators.map((c) => {
                  const employment = c.collaboratorEmployments[0];

                  return (
                    <tr key={c.id}>
                      <td>{c.name}</td>
                      <td>{c.taxNumber}</td>
                      <td>{c.email}</td>
                      <td>{c.phone}</td>
                      <td>{employment?.jobTitle || "-"}</td>
                      <td>{formatCurrency(employment?.salary)}</td>

                      <td>
                        <span
                          className={`status-badge ${c.status === "ACTIVE"
                            ? "active"
                            : "inactive"
                            }`}
                        >
                          {c.status}
                        </span>
                      </td>

                      <td
                        style={{
                          textAlign: "right",
                          position: "relative",
                        }}
                      >
                        <button
                          style={{ color: "black" }}
                          className="action-menu-btn"
                          onClick={() =>
                            setOpenDropdown(
                              openDropdown === c.id ? null : c.id
                            )
                          }
                        >
                          <FiMoreVertical size={16} />
                        </button>

                        {openDropdown === c.id && (
                          <div className="dropdown-menu">
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                navigate(
                                  `/folha-pagamento/colaborador/${c.id}`)
                                setOpenDropdown(null);
                              }}
                            >
                              <FiEdit size={14} /> Editar
                            </button>
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                setSelectedCollaborator(c);
                                setIsModalOpen(true);
                                setOpenDropdown(null);
                              }}
                            >
                              <FiTrash size={14} /> Encerrar vínculo
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div className="pagination">
              <button
                disabled={page === 1}
                onClick={() => handleList(page - 1)}
              >
                Anterior
              </button>

              <span>
                Página {page} de {pagination.totalPages || 1}
              </span>

              <button
                disabled={page === pagination.totalPages}
                onClick={() => handleList(page + 1)}
              >
                Próxima
              </button>
            </div>

            {loading && (
              <div style={{ textAlign: "center", padding: "20px" }}>
                Carregando...
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Encerrar vínculo</h3>

            <p>
              Informe a data de término do vínculo com{" "}
              <strong>{selectedCollaborator?.name}</strong>.
            </p>

            <input
              type="date"
              className="form-control"
              value={terminationDate || ""}
              onChange={(e) => setTerminationDate(e.target.value)}
            />

            <div className="modal-actions">
              <button
                className="payroll-secondary-action"
                onClick={() => {
                  setIsModalOpen(false);
                  setTerminationDate(null);
                }}
              >
                Cancelar
              </button>

              <button
                className="payroll-primary-button"
                onClick={handleInactiveCollaborator}
                disabled={!terminationDate || loading}
              >
                {loading ? "Salvando..." : "Confirmar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}